import 'core-js/stable';
import 'regenerator-runtime/runtime';
import { createRoot } from 'react-dom/client';
import '@saucelabs/sl-style-main';
import './tailwind.css';
import './utils/LogRocket';
import '@saucelabs/sl-util-sentry';
import '@saucelabs/sl-util-backtrace';
import config from '@saucelabs/sl-util-config';

import router from './router';

config.load(window.WEB_SETTINGS);
const root = createRoot(document.getElementById('app'));
root.render(router);

import '@saucelabs/sl-style-font/lib/fonts.css'; // eslint-disable-line

if (module.hot) module.hot.accept();
